import { Injectable, NgModule, inject } from '@angular/core';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard,
  CoreUtilsService
} from '@bepatient/core';
import { Store } from '@ngrx/store';
import {
  selectorMyEdiary,
  MyEdiaryActionLoadEdiary
} from '@bepatient/my-ediary-store';
import { EdiaryUtilsService } from './services/ediary-utils.service';

@Injectable()
export class MyEdiaryGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(store, selectorMyEdiary, new MyEdiaryActionLoadEdiary());
  }
}

const myEdiaryModule: CorePageModule = {
  ID: CorePageModuleIDs.EDIARY,
  i18nLabel: 'MODULES.EDIARY',
  icon: 'copy',
  leftMenuAvailableForPages: [0],
  routes: [
    {
      path: 'ediary',
      canActivate: [MyEdiaryGuard],
      loadChildren: () =>
        import('./pages/my-ediary/my-ediary.module').then(
          module => module.MyEdiaryPageModule
        )
    },
    {
      path: 'ediary/detail',
      loadChildren: () =>
        import('./pages/my-ediary-detail/my-ediary-detail.module').then(
          module => module.MyEdiaryDetailPageModule
        )
    },
    {
      path: 'ediary/list',
      loadChildren: () =>
        import('./pages/my-ediary-activities/my-ediary-activities.module').then(
          module => module.MyEdiaryActivitiesPageModule
        )
    }
  ]
};

@NgModule({
  providers: [
    MyEdiaryGuard,
    EdiaryUtilsService,
    { provide: CORE_PAGE_MODULE, useValue: myEdiaryModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './my-ediary/i18n/', multi: true }
  ]
})
export class MyEdiaryModule {
  constructor() {
    const coreUtilsService = inject(CoreUtilsService);

    coreUtilsService.addDepthModuleRoutes(myEdiaryModule);
  }
}
